/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import { getCMSObject, TeleScript } from 'sg-ui-components';

import EntryForm from './entry_form';
import ModalBox from '../ModalBox';
import Error from './error';
import ticketFront from '../../images/ticket-front.svg';

export const EntryInner = ({ drawTicket, game, animation, actions }) => {
    const resetEnterTicketStatus = () => {
        actions.animationActions.reset();
    };

    useEffect(() => {
        resetEnterTicketStatus();
        actions.drawTicketActions.reset();
    }, []);
    useEffect(() => {
        const handleIGRMessages = (event) => {
            if (event.data && event.data.type === 'enterTicket') {
                actions.animationActions.reset();
            }
        };

        window.addEventListener('message', handleIGRMessages);

        return () => {
            window.removeEventListener('message', handleIGRMessages);
        };
    }, [actions.animationActions]);

    return (
        <div className='entry-inner my-2'>
            <div id='entry-alert' className='entry-alert'>
                <Error />
            </div>

            <div className='entry-container'>
                <div className='entry-panel'>
                    <EntryForm drawTicket={drawTicket} game={game} actions={actions} createfunc={actions.drawTicketActions.enterDrawTicket} />
                </div>

                <div className='ticket-card'>
                    <div className='ticket-img-wrapper'>
                        <img
                            src={ticketFront}
                            alt='ENTRY NUMBER ON FRONT Entry Number is the  11 digit number on the FRONT of the ticket under the scratch covering below the play area.'
                            className='ticket-front'
                        />
                    </div>

                    <div className='ticket-info'>
                        <TeleScript line={getCMSObject('data.microsite.general.ticketEntry.findScratchNumbers.contentHTML')} />
                    </div>
                </div>
            </div>
            {animation?.gameUrl && (
                <ModalBox className='reveal-game-container' closeCallback={resetEnterTicketStatus}>
                    <object className='reveal-game' type='text/html' data={animation?.gameUrl.game}></object>
                </ModalBox>
            )}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryInner);
